/**
 * Account screen: shows the silent guest identity, the "validate account"
 * form (guest -> named account with email verification), login for existing
 * accounts and logout. Also drives the profile chip on the menu.
 */
export default class AccountScreen {
  constructor({ auth, onBack }) {
    this.auth = auth;
    this.onBack = onBack;

    this.chipName = document.getElementById('account-chip-name');
    this.chip = document.getElementById('btn-account');
    this.subtitle = document.getElementById('account-subtitle');
    this.username = document.getElementById('account-username');
    this.detail = document.getElementById('account-detail');
    this.verifyBanner = document.getElementById('account-verify-banner');
    this.offlineBanner = document.getElementById('account-offline-banner');
    this.convertCard = document.getElementById('account-convert-card');
    this.loginCard = document.getElementById('account-login-card');
    this.logoutCard = document.getElementById('account-logout-card');

    document.getElementById('btn-account-back')?.addEventListener('click', () => this.onBack?.());
    document.getElementById('btn-logout')?.addEventListener('click', async () => {
      await this.auth.logout();
      this.refresh();
    });
    document.getElementById('btn-resend-verification')?.addEventListener('click', async (event) => {
      event.target.disabled = true;
      await this.auth.resendVerification();
      event.target.textContent = 'ENVOYÉ ✓';
    });

    document.getElementById('form-convert')?.addEventListener('submit', (e) => this._onConvert(e));
    document.getElementById('form-login')?.addEventListener('submit', (e) => this._onLogin(e));

    this.auth.onChange = () => this.refresh();
    this.refresh();
  }

  refresh() {
    const user = this.auth.user;

    // Menu chip: guest gets a discreet label, named account gets its username.
    if (this.chipName) {
      this.chipName.textContent = user ? user.username : 'HORS LIGNE';
    }
    this.chip?.classList.toggle('account-chip--guest', !user || user.isGuest);

    if (!this.username) return;

    if (!user) {
      this.subtitle.textContent = 'HORS LIGNE';
      this.username.textContent = '—';
      this.detail.textContent = 'Tes scores restent enregistrés sur cet appareil.';
      this.offlineBanner?.classList.remove('hidden');
      this.verifyBanner?.classList.add('hidden');
      this.convertCard?.classList.add('hidden');
      this.loginCard?.classList.add('hidden');
      this.logoutCard?.classList.add('hidden');
      return;
    }

    this.offlineBanner?.classList.add('hidden');
    this.username.textContent = user.username;

    if (user.isGuest) {
      this.subtitle.textContent = 'COMPTE INVITÉ';
      this.detail.textContent = 'Ce compte invité te suit automatiquement à chaque visite sur cet appareil.';
      this.verifyBanner?.classList.add('hidden');
      this.convertCard?.classList.remove('hidden');
      this.loginCard?.classList.remove('hidden');
      this.logoutCard?.classList.add('hidden');
    } else {
      this.subtitle.textContent = 'COMPTE VALIDÉ';
      this.detail.textContent = user.email || '';
      this.verifyBanner?.classList.toggle('hidden', user.emailVerified);
      this.convertCard?.classList.add('hidden');
      this.loginCard?.classList.add('hidden');
      this.logoutCard?.classList.remove('hidden');
    }
  }

  async _onConvert(event) {
    event.preventDefault();
    const error = document.getElementById('convert-error');
    error?.classList.add('hidden');

    const result = await this.auth.convert({
      username: document.getElementById('convert-username')?.value.trim(),
      email: document.getElementById('convert-email')?.value.trim(),
      password: document.getElementById('convert-password')?.value
    });

    if (result.ok) {
      this.refresh();
    } else if (error) {
      error.textContent = result.message;
      error.classList.remove('hidden');
    }
  }

  async _onLogin(event) {
    event.preventDefault();
    const error = document.getElementById('login-error');
    error?.classList.add('hidden');

    const result = await this.auth.login({
      username: document.getElementById('login-username')?.value.trim(),
      password: document.getElementById('login-password')?.value
    });

    if (result.ok) {
      this.refresh();
    } else if (error) {
      error.textContent = result.message;
      error.classList.remove('hidden');
    }
  }
}
